import './Immigration.scss';

export default function Immigration() {
    return (
        <div id="immigration">
            <div className="centered-container">
                <h1>Immigration</h1>
                <p>Immigration information goes here.</p>
            </div>
        </div>
    );
}